import React from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import { formatPhoneNumber } from "../utils/formatPhone";
import type { TrustCallPhone } from "../types";

interface PhoneNumberCellProps extends GridCellProps {
  isTrustCallV3: boolean;
  onDetailsClick?: (phone: TrustCallPhone) => void;
}

const PhoneNumberCell: React.FC<PhoneNumberCellProps> = (props) => {
  const dataItem = props.dataItem as TrustCallPhone;

  return (
    <td>
      <div>
        <strong>{formatPhoneNumber(dataItem.phoneNumber)}</strong>
      </div>
      {props.isTrustCallV3 && dataItem.hasCallScreenShot && props.onDetailsClick && (
        <button
          className="btn btn-primary btn-sm mt-1"
          onClick={() => props.onDetailsClick!(dataItem)}
        >
          Details
        </button>
      )}
    </td>
  );
};

export default PhoneNumberCell;
